/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getSharedItem, selectedContentData, updateSideMenu } from '../../../redux/UserSessionSlice';
import '../styles.css';
import CloseIcon from '@mui/icons-material/Close';
import { isTouchDevice, roleCondition, canAccessBusinessProspects } from '../../../libs/HelperContent';
import { HamburgerContext, LanguageContext, NewsFeedContext } from '../../../libs/Context';
import { Badge, Tooltip } from '@mui/material';
import { certifciteTab, getConnectionData, MarkingTab, setFeedNetworkRelation, updateFollowPath, updatePendingPath, updateRFilter } from '../../../redux/NetworkRedux';
import { getUpdateDeal } from '../../../redux/DealRedux';
import { updateEmployeeDep, updateEmployeeDes } from '../../../redux/EmployeeRedux';
import { getFeedData } from '../../../redux/NewsFeedRedux';
import { fetchResourceData } from '../../../redux/ResourceRedux';
import { LoginContext } from '../../../App';
import { setCheckUpload } from '../../../redux/MyResourceRedux';
import { GetSideMenu } from '../../../containers/actions/business_settings';
import { SideMenuRoutes } from '../../../libs/SideMenuRoutes';
import BusinessProfile from '../../../assets/SideNavIcons/Business_Profile.svg';
import BusinessSettings from '../../../assets/SideNavIcons/Settings.svg';
import Resources from '../../../assets/SideNavIcons/Resources.svg';
import NewsFeedIcon from '../../../assets/SideNavIcons/News_Feed.svg';
import NetworkIcon from '../../../assets/SideNavIcons/Network.svg';
import MeetingIcons from '../../../assets/SideNavIcons/Meeting.svg';
import Dashboard from '../../../assets/SideNavIcons/Dashboardsidenavicon.svg';
import ProductWarrantyIcon from '../../../assets/SideNavIcons/Product_Warrenty.svg';
import AffiliateIcon from '../../../assets/SideNavIcons/Affiliate_Programme.svg';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';

interface Group {
	unseenMsgCount: number;
  }
  interface GroupIds {
	[key: string]: Group;
  }

const BusinessSideNav = (props: any) =>
{
	const { language } = useContext(LanguageContext);
	const currentPathArr = window.location.pathname.split('/');
	const isCustom = [ 'custom', 'outroute' ].includes(currentPathArr[1]);
	let activePath = currentPathArr[isCustom ? 2 : 1];
	const isBusinessSettings = activePath === 'businessSettings';

	activePath = isBusinessSettings ? `/${currentPathArr[1]}/${currentPathArr[2]}` : activePath;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const userData = useSelector((state: any) => state?.mysession?.session);
	const menuData = useSelector((state: any) => state?.mysession?.sideMenuData);
	const userConfigs = useSelector((state:any) => state?.mysession?.userConfigs);
	const isDashboardAdmin = userConfigs?.dashboardManagement?.isAdmin;
	const accessConfigs = useSelector((state:any) => state?.mysession?.otherConfigs);
	const connnectionBadgeCount = useSelector((state: any) => state?.mynetwork?.badgeCount?.connnectionBadgeCount);
	const contractBadgeCount = useSelector((state: any) => state?.mynetwork?.badgeCount?.contractBadgeCount);
	const relationsArray: any = useSelector((state: any) => state?.mynetwork?.feedNetworkRelations);
	const deal = useSelector((state: any) => state?.mysession?.deal);
	const feedData = useSelector((state: any) => state?.mynewsFeed?.feedData);
	const { setHamBurgerShow, setContactHamber, setShowSideNavIcons, showSideNavIcons } = useContext(HamburgerContext);
	const chatUnreadCount = useSelector((state: any) => state?.mychat?.chatUnreadCount);
	const { setMenuItem } = useContext(NewsFeedContext);
	const { setCatTab, catTab } = useContext(LoginContext);
	const viewMyResourceUploadFile = useSelector((state: any) => state.viewmyresource.uploadFile);
	const [ borderIndex, setBorderIndex ] = useState<any>([ 4 ]);
	const currentSelectedRef = useRef<HTMLDivElement | null>(null);
	const [ loading, setLoading ] = useState<boolean>(false);

	const getContractsHideValue = () => // to get hide value for contracts menu (sent and recieved contracts)
	{
		return !(userConfigs?.contractAccess?.isContractEmp &&
			(userConfigs?.contractAccess?.viewContract || userConfigs?.contractAccess?.authorization));
	};

	const getDealHideValue = () => !deal?.dealStatus;

	const groupIds:GroupIds = useSelector((state: any) => state?.mypresence?.groupIds) || {};

	const unseenGroupCount = Object.values(groupIds).reduce((count, { unseenMsgCount }) =>
	{
		return unseenMsgCount > 0 ? count + 1 : count;
	}, 0);

	const getSideMenu = async (retryCount = 3) =>
	{
		setLoading(true);
		const query: any = { platform: [ 1 ] };

		try
		{
			const res = await GetSideMenu(query);

			if (res?.data && res.data.length > 0)
			{
				const newData: any = [];

				for (const i of res.data)
				{
					if (i.isEnabled)
					{
						const updatedData = i?.type === 1
							? { ...i, ...SideMenuRoutes[i.index] }
							: i;

						if (i.index === 14)
						{
							updatedData.hide = getContractsHideValue();
						}
						if (i.index === 11)
						{
							updatedData.hide = getDealHideValue();
						}

						newData.push(updatedData);
					}
				}

				dispatch(updateSideMenu([ ...newData ]));
				setLoading(false);
			}
			else
			{
				console.log(retryCount, '----retrycount busines side nav');
				if (retryCount > 0)
				{
					await new Promise((resolve) => setTimeout(resolve, 1000));
					await getSideMenu(retryCount - 1);
				}
				setLoading(false);
			}
		}
		catch (err)
		{
			setLoading(false);
			console.log(err, '--------err');
		}
	};

	// const getSideMenu = () =>
	// {
	// 	const query: any = { platform: [ 1 ] };

	// 	GetSideMenu(query)
	// 		.then((res: any) =>
	// 		{
	// 			const newData: any = [];

	// 			for (const i of res?.data)
	// 			{
	// 				if (i.isEnabled)
	// 				{
	// 					const updatedData = i?.type === 1
	// 						? { ...i, ...SideMenuRoutes[i.index] }
	// 						: i;

	// 					if (i.index === 14) // for contract access menu item
	// 					{
	// 						updatedData.hide = getContractsHideValue();
	// 					}
	// 					if (i.index === 11) // for deal menu item
	// 					{
	// 						updatedData.hide = getDealHideValue();
	// 					}

	// 					newData.push(updatedData);
	// 				}
	// 			}

	// 			dispatch(updateSideMenu([ ...newData ]));
	// 		})
	// 		.catch((err: any) =>
	// 		{
	// 			console.log('-------------', err);
	// 		});
	// };

	const validateSideMenu = () =>
	{
		const updatedMenu = menuData.map((item) =>
		{
			if (item.index === 14) // for contract access menu item
			{
				return {
					...item,
					hide : getContractsHideValue()
				};
			}
			else if (item.index === 11) // for deal menu item
			{
				return {
					...item,
					hide : getDealHideValue()
				};
			}

			return item;
		});

		dispatch(updateSideMenu(updatedMenu));
	};

	useEffect(() =>
	{
		if (menuData?.length <= 0 && userData?.role !== 'individual' && Object?.keys(userData ?? {})?.length > 0)
		{
			getSideMenu();
		}
		if (activePath === 'collaboration')
		{
			setShowSideNavIcons(true);
		}
	}, []);

	useEffect(() =>
	{
		if (menuData?.length > 0 && userData?.role !== 'individual' && Object.keys(userData ?? {})?.length > 0)
		{
			validateSideMenu();
		}
	}, [ userData?.userId, userConfigs?.contractAccess?.isContractEmp, userConfigs?.contractAccess?.viewContract, userConfigs?.contractAccess?.authorization, deal?.dealStatus ]);

	// const currentPathname = window.location.pathname;

	const businessOptions = [
		{
			id         : '17',
			linkPath   : '/businessProfile',
			icon       : BusinessProfile,
			name       : 'Business Profile',
			errSrcPath : 'profile.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'employee' ]
		},
		{
			id         : '18',
			linkPath   : isDashboardAdmin ? '/businessSettings/businessDashboard' : 'businessSettings/businessProfile',
			icon       : BusinessSettings,
			name       : 'Manage Business',
			errSrcPath : 'setting.svg',
			role       : [ 'company' ],
			empRole    : [ 'superAdmin', 'admin' ]
		},
		{
			id         : '19',
			linkPath   : '/businessSettings/content',
			icon       : Resources,
			name       : 'Content',
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee' ],
			empRole    : userConfigs?.employeePermissions?.permissions?.view ? [ 'employee' ] : []
		},
		{
			id       : '20',
			linkPath : '/dashboard',
			isActive	: roleCondition(userData?.empRole)
				? [ '/dashboard' ].includes(activePath)
				: [ '/businessSettings/businessDashboard', '/dashboard' ].includes(activePath),
			icon       : Dashboard,
			name       : 'Dashboard',
			errSrcPath : 'profile.svg',
			role       : [ 'company', 'employee' ],
			empRole    : [ 'employee', 'admin', 'superAdmin' ]
		}
		// {
		// 	id         : '20',
		// 	linkPath   : '/resourcemanagement',
		// 	icon       : Resources,
		// 	name       : 'Resources old',
		// 	errSrcPath : 'collabration_icon_gray.svg',
		// 	role       : [ 'company', 'employee' ],
		// 	empRole    : [ 'superAdmin', 'admin', 'employee' ]
		// }
		// {
		// 	id         : '21',
		// 	linkPath   : '/businessSettings/contentold',
		// 	icon       : Resources,
		// 	name       : 'Content management old',
		// 	errSrcPath : 'collabration_icon_gray.svg',
		// 	role       : [ 'company', 'employee' ],
		// 	empRole    : [ 'superAdmin', 'admin', 'employee' ]
		// }
	];

	const individualOptions = [
		{
			id         : '0',
			linkPath   : '/news',
			srcPath    : NewsFeedIcon,
			title      : 'News Feed', // language?.newsFeed
			errSrcPath : 'new-feed.svg',
			role       : [ 'company', 'employee', 'individual' ]
		},
		{
			id       : '2',
			linkPath : '/connections',
			srcPath  : NetworkIcon,
			title    : 'Networks', // language?.networks,
			errSrc   : 'network.svg',
			role     : [ 'company', 'employee', 'individual' ]
		},
		{
			id         : '2',
			linkPath   : '/meetings',
			svgPath    : MeetingIcons,
			srcPath    : MeetingIcons,
			title      : 'Meeting', // language?.meetingWeb,
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee', 'individual' ]

		},
		{
			id         : '3',
			linkPath   : '/productWarranty',
			srcPath    : ProductWarrantyIcon,
			title      : 'Product Warranty', // language?.productWarranty,
			errSrcPath : 'collabration_icon_gray.svg',
			role       : [ 'company', 'employee', 'individual' ]

		},
		{
			id         : '4',
			linkPath   : '/affiliate',
			srcPath    : AffiliateIcon,
			title      : 'Affiliate Programme', // language?.affiliate,
			errSrcPath : 'affiliate_gray.svg',
			role       : [ 'company', 'employee', 'individual' ]

		}
	];

	const returnFunction = () =>
	{
		dispatch(getFeedData({ archieved: (feedData?.archieved).slice(0, 10), active: (feedData?.active).slice(0, 10) }));
		setHamBurgerShow(false);
		dispatch(updateEmployeeDep([]));
		dispatch(updateEmployeeDes([]));
		dispatch(selectedContentData({}));
		dispatch(getUpdateDeal(null));
		dispatch(certifciteTab(0));
		dispatch(MarkingTab(0));
		dispatch(setFeedNetworkRelation({ page: 0, relations: relationsArray?.relations?.slice(0, 10) }));
	};

	const handleData = useCallback((linkPath: any) =>
	{
		if (activePath !== 'connections')
		{
			dispatch(getConnectionData({ value: 0 }));
		}
		dispatch(getFeedData({ archieved: (feedData?.archieved).slice(0, 10), active: (feedData?.active).slice(0, 10) }));
		dispatch(setFeedNetworkRelation({ page: 0, relations: relationsArray?.relations?.slice(0, 10) }));
		dispatch(selectedContentData({}));
		dispatch(updateFollowPath(''));
		dispatch(updatePendingPath(''));
		dispatch(getUpdateDeal(null));
		dispatch(certifciteTab(0));
		dispatch(MarkingTab(0));
		dispatch(fetchResourceData({ categoryData: {} }));
		dispatch(getSharedItem(''));
		if (linkPath === '/collaboration')
		{
			navigate(linkPath);
			props?.handleCloseRespSideNav();
		}
		else
		{
			navigate(linkPath);
		}
		setMenuItem('');
		setCatTab(linkPath !== '/resources' ? 0 : catTab);
	}, [ props ]);

	useEffect(() =>
	{
		if (activePath !== 'connections')
		{
			dispatch(updateRFilter([]));
			dispatch(getConnectionData({ value: 0 }));
		}
		dispatch(getFeedData({ archieved: (feedData?.archieved).slice(0, 10), active: (feedData?.active).slice(0, 10) }));
		dispatch(updateEmployeeDep([]));
		dispatch(updateEmployeeDes([]));
		dispatch(getUpdateDeal(null));
		dispatch(certifciteTab(0));
		dispatch(MarkingTab(0));
		dispatch(setFeedNetworkRelation({ page: 0, relations: relationsArray?.relations?.slice(0, 10) }));
		setMenuItem('');
	}, [ activePath ]);

	const openSideMenu = (menu) =>
	{
		if (viewMyResourceUploadFile.length > 0)
		{
			dispatch(setCheckUpload(true));

			return;
		}
		dispatch(getFeedData({ archieved: (feedData?.archieved).slice(0, 10), active: (feedData?.active).slice(0, 10) }));
		dispatch(selectedContentData({}));
		dispatch(updateFollowPath(''));
		dispatch(updatePendingPath(''));
		dispatch(getUpdateDeal(null));
		dispatch(certifciteTab(0));
		dispatch(MarkingTab(0));
		dispatch(getSharedItem(''));
		navigate(menu?.type === 2
			? menu?.openInlynk
				? `/custom/${window.btoa(menu?.url)}`
				: `/outroute/${window.btoa(menu?.url)}`
			: menu.linkPath);
		setContactHamber(false);
		setHamBurgerShow(false);
		setCatTab(activePath !== '/resources' ? 0 : catTab);
		setMenuItem('');
		setShowSideNavIcons(menu?.index === 2); // for collaboration only
	};

	const getIndexForBorder = () =>
	{
		let highestValue: any = menuData[0]?.index;

		for (let i = 1; i < menuData?.length; i++)
		{
			const value: any = menuData[i]?.index;

			if (value > highestValue)
			{
				highestValue = value;
			}
		}

		setBorderIndex([ ...borderIndex, highestValue ]);
	};

	useEffect(() =>
	{
		if (userData?.userId)
		{
			getIndexForBorder();
		}
	}, [ menuData ]);

	const handleMenuClick = () =>
	{
		setShowSideNavIcons(!showSideNavIcons);
	};

	const handleBusines = (each) =>
	{
		each?.linkPath !== '/profile' && showSideNavIcons && setShowSideNavIcons(!showSideNavIcons);
		handleData(each?.linkPath);
	};
	// const checkToOpen = ([ '/businessSettings', '/profileSettings', '/certificationExam', '/examStatus', '/createNewTemplate', '/collaboration' ]?.includes(`/${activePath}`));

	useEffect(() =>
	{
		if (currentSelectedRef?.current)
		{
			currentSelectedRef.current.scrollIntoView({ block: 'center' });
		}
	}, [ currentSelectedRef ]);

	// useEffect(() =>
	// {
	// 	if (window.location.pathname === '/collaboration')
	// 	{

	// 	}
	// }, [ window.innerWidth ]);

	// useEffect(() =>
	// {
	// 	console.log(window.innerHeight, 'window.innerHeight');
	// 	if (window.innerHeight < 460)
	// 	{
	// 		setShowSideNavIcons(false);
	// 	}
	// }, [ window.innerHeight ]);

	// useEffect(() =>
	// {
	// 	const handleResize = () =>
	// 	{
	// 		if (window.innerHeight < 460)
	// 		{
	// 			setShowSideNavIcons(false);
	// 		}
	// 		else
	// 		{
	// 			setShowSideNavIcons(true);
	// 		}
	// 	};

	// 	handleResize();
	// 	window.addEventListener('resize', handleResize);

	// 	return () =>
	// 	{
	// 		window.removeEventListener('resize', handleResize);
	// 	};
	// }, []);
	// const dasboardActive = (currentPathname === '/dashboard' || (isDashboardAdmin && currentPathname === '/businessSettings/businessDashboard'));

	return (
		<>
			<div className='flexRow alignCntr justifyEnd pdngXSlogoCntnr dskdisplaRnot '>
				{loading && <Loading/>}
				{/* {!checkToOpen && <div className='flexAutoRow pointer alignCntr jusifyCntr pdngHXS MobdisplaRnot' onClick={handleMenuClick}>
					{showSideNavIcons
						? <RiMenuUnfoldFill fontSize='var(--pixel20)' />
						: <RiMenuFoldFill fontSize='var(--pixel20)' />}

				</div>} */}
				{/* {!showSideNavIcons && <InLinkLogo handleCloseRespSideNav={props?.handleCloseRespSideNav} />} */}
				{activePath !== 'collaboration' && <div className='flexAutoRow pdngVXS' >
					<span className='mobLogoNone' onClick={() => { setHamBurgerShow(false); setShowSideNavIcons(false); }} >
						<Tooltip title={language?.close} placement='top-start' >
							<CloseIcon className='pointer' />
						</Tooltip>
					</span>
				</div>}
			</div>
			{/* <div className='flexRow justifyEnd pdngSM dskdisplaRnot'>
				<div className='flexAutoRow'>
					<div className='ProfilePic'>
						<Image src={userData?.profileImage ? userData?.profileImage : '/images/icons/employee.svg'} alt='profilePic' className='brdrRadius50'
							fallback={<svg viewBox='0 0 48 48' className='brdrRadius50'><path fill='#215288' stroke='#475a42' strokeWidth='0' d='M0-8.68c4.792 0 8.68 3.888 8.68 8.68S4.793 8.68 0 8.68-8.68 4.793-8.68 0-4.793-8.68 0-8.68z' transform='matrix(1.19 0 0 1.4 24.72 12.24)' vectorEffect='non-scaling-stroke' /><path fill='#215288' stroke='#de0998' strokeWidth='0' d='M.04 36.528a6.087 6.087 0 013.763-5.641c.922-.38.86-.372 2.684-1.39 1.847-1.032 7.494-3.307 10.41-4.336l-5.178 4.845 6.389-1.179 6.68 11.391 6.204-11.39 5.315 1.178-4.204-4.968c2.566.994 8.296 3.527 10.015 4.458 1.755.951 1.575.907 2.423 1.171a4.842 4.842 0 013.4 4.644l-.035 12.65-47.834.001z' vectorEffect='non-scaling-stroke' /><path fill='#215288' stroke='var(--black)' strokeWidth='0' d='M24.801 21.366c-2.973 0-4.248-1.187-6.159-2.188h0a.039.039 0 00-.056.037l.389 7.936L24.8 37.442l5.408-10.291.785-8.013s-3.188 2.228-6.193 2.228z' vectorEffect='non-scaling-stroke' /></svg>}
						/>
					</div>
				</div>
				<div className='flexMinWidthCol'>
					<div className='flexRow pdngHXS'>
						<span className='capitalTxt titleHeading headingLG ellipsisTxt'>
							{userData?.firstName
								? userFullName(userData)
								: userData?.companyName}
						</span>
					</div>
					<div className='flexRow pdngHXS'>
						<span className='ellipsisTxt'>
							{userData?.email ? userData?.email : ''}
						</span>
					</div>
				</div>
			</div> */}
			<ul className={`flexMinHeightCol resSideNavGroup pdngBSM scrollXHidden ${isTouchDevice() ? 'scrollY' : 'scrollbarSideNav brdrRght'}`}>
				{userData?.role !== 'individual'
					? menuData?.map((each: any) =>
					{
						const dataPath = isCustom ? window.btoa(each?.url) : each?.linkPath?.split('/')[1];

						const activeNav =
							activePath === dataPath ? 'invertPrimary' : 'invertGray';
						const activeText =
							activePath === dataPath ? 'activeText' : '';
						const activeLink =
							activePath === dataPath ? 'activeLink' : '';

						const showBorder = borderIndex.includes(each?.index);

						// Check if menu item should be hidden based on access rules
						const shouldHideBusinessProspects = each?.linkPath === '/businessprospects' && !canAccessBusinessProspects(userData, accessConfigs);
						const shouldHideDeal = !roleCondition(userData?.empRole) && each?.index === 11 && !deal?.dealStatus;
						const shouldHideItem = shouldHideBusinessProspects || shouldHideDeal;

						return !each?.hide && (
							<li key={`${each?.name}-${each?.index}`} className={`resNavItem pointer ${shouldHideItem ? 'displayNone' : ''}`} onClick={() => openSideMenu(each)}>
								<div className={`resNavLink ${activeLink} ${showBorder ? 'brdrBSM' : ''}`} onClick={() => setHamBurgerShow(false)} ref={activeLink ? currentSelectedRef : null}>
									<div className={`${showSideNavIcons && 'justifyCntr'} flexRow alignCntr pdngH40`}>
										<Tooltip title={`${showSideNavIcons ? each.name : ''}`}>
											<div className='flexAutoRow pdngHXS'>
												<div className={`resNavIcons ${activeNav} flexInline jusifyCntr alignCntr`}>
													<img src={each?.type === 1 ? each?.icon : each?.iconMedia?.url} alt='icon' />
												</div>
											</div>
										</Tooltip>
										{!showSideNavIcons &&
											<div className='flexMinWidthRow alignCntr pdngRSM'>
												<span className={`resNavLinkTxt ${activeText} ellipsisTxt capitalTxt`}>
													{each?.name}
												</span>
												{each?.linkPath === '/collaboration' && <Badge color='primary' variant='standard' badgeContent={unseenGroupCount} sx={{ '& .MuiBadge-badge': { color: 'var(--whiteColor)' } }}/>}
												{each.linkPath === '/connections' && roleCondition(userData?.empRole) && <Badge color='primary' variant='standard' badgeContent={connnectionBadgeCount} sx={{ '& .MuiBadge-badge': { color: 'var(--whiteColor)' } }} />
												// dynamic data for badge networks in below
												// && <Badge color='primary' variant='standard' badgeContent={connnectionBadgeCount} />
												}
												{(each.linkPath === '/contractManagement') && <Badge color='primary' variant='standard' badgeContent={contractBadgeCount} />}
											</div>}
									</div>
								</div>
							</li>
						);
					})
					: <div className='flexCol'>
						{individualOptions.map((each, index: any) =>
						{
							const activeNav =
								activePath === each.linkPath.split('/')[1] ? 'invertPrimary' : 'invertGray';
							const activeText =
								activePath === each.linkPath.split('/')[1] ? 'activeText' : '';
							const activeLink =
								activePath === each.linkPath.split('/')[1] ? 'activeLink' : '';

							return (
								<div className={`flexRow resNavLink ${activeLink}`} key={index} onClick={returnFunction} ref={activeLink ? currentSelectedRef : null}>
									<div className='flexAutoRow pdngHXS'>
										<div className={`resNavIcons ${activeNav} flexInline jusifyCntr alignCntr`}>
											{each?.svgPath
												? <div className='sideNameIcon'>
													<img src={each?.svgPath} alt='navIcons'/>
												</div>
												: <img src={`${each.srcPath}`}/>
											}
										</div>
									</div>
									{!showSideNavIcons &&
										<div className='flexMinWidthCol pointer pdngRSM'>
											<span className={`resNavLinkTxt ${activeText} ellipsisTxt capitalTxt`} onClick={() => handleData(each.linkPath)}>
												{each.title}
											</span>
										</div>}
								</div>
							);
						}
						)}
					</div>}
			</ul>
			{userData?.role !== 'individual' &&
				<div className='flexCol justifyEnd brdrTSM'>
					{businessOptions.map((each: any) =>
					{
						const isActive = each?.isActive ||
							activePath === (isBusinessSettings ? each?.linkPath : each?.linkPath.split('/')[1]);

						const activeNav = isActive ? 'invertPrimary' : 'invertGray';
						const activeText = isActive ? 'activeText' : '';
						const activeLink = isActive ? 'activeLink' : '';

						return each?.empRole?.includes(userData?.empRole) && (
							<div key={each?.id}>
								{userData?.role !== 'individual' &&
									<div className={`resNavLink ${activeLink}`} onClick={() => { returnFunction(); handleBusines(each); }}>
										<div className={`${showSideNavIcons && 'justifyCntr'} flexRow alignCntr pdngH40 `}>
											<Tooltip title={`${showSideNavIcons ? each.name : ''}`}>
												<div className='flexAutoRow pdngHXS pointer' >
													<div className={`resNavIcons ${activeNav}flexInline jusifyCntr alignCntr`}>
														<img src={`${each?.icon}`} />
													</div>
												</div>
											</Tooltip>
											{!showSideNavIcons &&
												<div className='flexMinWidthRow pointer pdngRSM'>
													<span className={`resNavLinkTxt ${activeText} ellipsisTxt capitalTxt`} >
														{each?.name}
													</span>
												</div>}
										</div>
									</div>}
							</div>
						);
					})}
				</div>}
		</>
	);
};

export default BusinessSideNav;